import { render, staticRenderFns } from "./RulesSelectGroup.vue?vue&type=template&id=2ce7bf60"
import script from "./RulesSelectGroup.vue?vue&type=script&lang=js"
export * from "./RulesSelectGroup.vue?vue&type=script&lang=js"
import style0 from "./RulesSelectGroup.vue?vue&type=style&index=0&id=2ce7bf60&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports